import React from 'react'

export const MapLocationIllustration: React.FC = () => {
  return (
    <svg
      width="400"
      height="250"
      viewBox="0 0 400 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(50, 30)">
        {/* 地图与定位标记 */}
        <rect
          x="20"
          y="20"
          width="260"
          height="160"
          rx="5"
          fill="#BEDCFE"
          opacity="0.5"
        />

        {/* 地图上的路线 */}
        <path
          d="M50,50 C80,30 120,80 150,70 C180,60 220,100 250,120"
          stroke="#4E6BFE"
          strokeWidth="3"
          fill="none"
          strokeDasharray="5,5"
        />

        {/* 位置标记 */}
        <g transform="translate(50, 50)">
          <path
            d="M0,0 C0,-15 20,-15 20,0 C20,10 10,25 10,25 C10,25 0,10 0,0 Z"
            fill="#FFC043"
          />
          <circle cx="10" cy="8" r="5" fill="white" />
        </g>

        <g transform="translate(250, 120)">
          <path
            d="M0,0 C0,-15 20,-15 20,0 C20,10 10,25 10,25 C10,25 0,10 0,0 Z"
            fill="#FFC043"
          />
          <circle cx="10" cy="8" r="5" fill="white" />
        </g>

        {/* 包裹图标 */}
        <g transform="translate(140, 100)">
          <rect x="0" y="0" width="30" height="30" fill="#4E6BFE" />
          <rect x="5" y="5" width="20" height="20" fill="white" />
          <line
            x1="5"
            y1="15"
            x2="25"
            y2="15"
            stroke="#4E6BFE"
            strokeWidth="2"
          />
          <line
            x1="15"
            y1="5"
            x2="15"
            y2="25"
            stroke="#4E6BFE"
            strokeWidth="2"
          />
        </g>

        {/* 商店/快递点图标 */}
        <g transform="translate(190, 60)">
          <rect x="0" y="0" width="25" height="25" fill="#4E6BFE" />
          <rect x="5" y="15" width="15" height="10" fill="white" />
          <path d="M0,0 L25,0 L12.5,-10 Z" fill="#4E6BFE" />
        </g>
      </g>
    </svg>
  )
}

export default MapLocationIllustration
